import React from 'react';
import './App.css';
import {configureStore} from './store';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {ThemedApp} from './ThemedApp';
import {configureAssert} from 'assert-ts';

const {store, persistor} = configureStore();

configureAssert({
  // TODO:
  warningReporter: (type, message, props) =>
    console.warn('Assertion failed: ', message || '', JSON.stringify(props)),
});

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemedApp />
      </PersistGate>
    </Provider>
  );
}

export default App;
